import { motion } from 'framer-motion';
import { Mail, Phone, MapPin } from 'lucide-react';

const Contact = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.5 },
  };

  return (
    <div data-testid="contact-page">
      {/* Hero Section */}
      <section className="py-12 md:py-12 mesh-gradient relative overflow-hidden" data-testid="contact-hero">
        <div className="absolute inset-0 bg-black/5 grid-pattern"></div>
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10">
          <motion.div {...fadeInUp} className="max-w-4xl">
            <div className="inline-flex items-center space-x-2 bg-[#B6671D]/10 text-[#B6671D]-dark rounded-full px-4 py-2 mb-6">
              <Mail size={20} />
              <span className="font-inter text-sm font-medium">Get in Touch</span>
            </div>
            <h1 className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-950 mb-6 tracking-tight">
              Contact <span className="text-[#B6671D]">Us</span>
            </h1>
            <p className="font-inter text-lg text-slate-600 leading-relaxed">
              Have questions about IRASM-2027? We're here to help. Reach out to us and we'll respond as soon as possible.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-20 bg-white" data-testid="contact-content">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
          {/* Contact Information */}
          <motion.div {...fadeInUp}>
            <h2 className="font-outfit text-3xl font-bold text-slate-950 mb-8">Get in Touch</h2>

            <div className="space-y-6">
              {/* Email */}
              
                            <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#B6671D]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail className="text-[#B6671D]" size={24} />
                </div>

                <div>
                  <h3 className="font-outfit text-lg font-bold text-slate-950 mb-1">Email</h3>

                  <div className="space-y-1">
                    <a
                      href="mailto:manish.rawat@jaipur.manipal.edu"
                      className="block font-inter text-slate-600 hover:text-[#B6671D] transition-colors"
                    >
                      manish.rawat@jaipur.manipal.edu
                    </a>

                    <a
                      href="mailto:krishna.pandey@jaipur.manipal.edu"
                      className="block font-inter text-slate-600 hover:text-[#B6671D] transition-colors"
                    >
                      krishna.pandey@jaipur.manipal.edu
                    </a>
                  </div>

                </div>
              </div>

              {/* Contact Persons */}
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#B6671D]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Phone className="text-[#B6671D]" size={24} />
                </div>
                <div>
                  <h3 className="font-outfit text-lg font-bold text-slate-950 mb-1">Contact Persons</h3>
                  <p className="font-inter text-slate-600">Dr. Manish Rawat</p>
                  <p className="font-inter text-slate-600">Dr. Krishna Kant Pandey</p>
                </div>
              </div>

              {/* Address */}
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#B6671D]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-[#B6671D]" size={24} />
                </div>
                <div>
                  <h3 className="font-outfit text-lg font-bold text-slate-950 mb-1">Address</h3>
                  <p className="font-inter text-slate-600 leading-relaxed">
                    Department of Mechatronics Engineering<br />
                    School of Engineering, FoSTA<br />
                    Manipal University Jaipur<br />
                    Dehmi Kalan, Jaipur, Rajasthan<br />
                    India
                  </p>
                </div>
              </div>
            </div>

            {/* Additional Info */}
            <div className="mt-8 bg-[#B6671D]/10 border-l-4 border-[#B6671D] p-6 rounded-r-lg">
              <p className="font-inter text-slate-700 leading-relaxed">
                For general inquiries about the conference, paper submissions, registration, or sponsorship
                opportunities, please reach out to us directly via email.
              </p>
            </div>
          </motion.div>

          {/* Contact Form - Commented out as per request
          <div className="bg-slate-50 border border-slate-200 rounded-xl shadow-lg p-8 mt-12">
            <h2 className="font-outfit text-2xl font-bold text-slate-950 mb-6">Send us a Message</h2>
            Form content here
          </div>
          */}
        </div>
      </section>
    </div>
  );
};

export default Contact;
